import * as React from "react";

import BaseProductGroupListLayout from "./BaseProductGroupListLayout";
import ProductGroupCreatePopup from "../containers/products/ProductGroupCreatePopup";

export default function () {
  return BaseProductGroupListLayout(<ProductGroupCreatePopup />);
}
